import WebLayout from './MaskedInputLayout.web';
import MobileLayout from './MaskedInputLayout.mobile';
import { isReactNative } from 'ui-builder';

export default isReactNative() ? MobileLayout : WebLayout;
